module.exports = __webpack_public_path__ + "img/b-mask_filipino-guy.09607d5.png";